import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';

export default function PolicyPage({ title, subtitle, sections }) {
  pageTitle(title);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageHeading
        title={title}
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText={subtitle || title}
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row justify-content-center">
          <Div className="col-lg-10">
            {sections.map((section, index) => (
              <Div key={`${section.heading}-${index}`} style={{ marginBottom: 40 }}>
                <h2 className="cs-font_30 cs-m0" style={{ marginBottom: 16 }}>
                  {section.heading}
                </h2>
                {section.paragraphs.map((paragraph, pIndex) => (
                  <p key={`${index}-${pIndex}`} style={{ marginBottom: 16, lineHeight: 1.8 }}>
                    {paragraph}
                  </p>
                ))}
              </Div>
            ))}
          </Div>
        </Div>
      </Div>
      <Spacing lg="110" md="60" />
    </>
  );
}
